var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"slide-inner\" ct-spinner=\"spinn\"> <div class=\"card-wr communal-pay\"> <h2><span class=\"icon-transfer-comunal\"></span>\n<span class=\"txt-name\">{{ 'WIDGET.COMMUNAL_TITLE' | translate }}</span></h2> <div class=\"comm-list\"> <a ng-click=\"toService(1)\" role=\"button\" tabindex=\"0\"><img src=\"" + require("../images/yasno.png") + "\" alt=\"Yasno\"/></a>\n<a ng-click=\"toService(0)\" role=\"button\" tabindex=\"0\"><img src=\"" + require("../images/gerc.png") + "\" alt=\"GERC\"/></a> </div> <div class=\"moreService\"> <a ui-sref=\"pages.services({categoryId: 37})\">{{\"ACTIONS.MORE_SERVICE\" | translate}}</a> </div> </div> </div>";
ngModule.run(["$templateCache",function(c){c.put("payments/templates/wg_communal.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/templates/wg_communal.html
 ** module id = 613
 ** module chunks = 1
 **/